import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button } from 'antd';
import moment from 'moment';
import auth from '../../../common/utility/auth';
import './styles.css';

import { REGISTRADO } from '../../../common/types/importacionEstadoType';
import { FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';

import Productos from './FormModal/Productos';
import Servicios from './FormModal/Servicios';
import Referencias from './FormModal/Referencias';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }


    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);
        if (numberDecimals === 0)
            return value === '' || isNaN(parseFloat(value).toFixed(0)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };


    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleCalculateProducto = (identifier, property, value, numberDecimals, _idProducto) => {
        var newValue = this.fetchNewValue(value, numberDecimals);

        var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${identifier}]`);
        var lote = property === "arrLote" ? value : this.props.form.getFieldValue(`arrLote[${identifier}]`);
        var nombre = property === "arrNombre" ? value : this.props.form.getFieldValue(`arrNombre[${identifier}]`);
        var cantidad = property === "arrCantidad" ? newValue : this.props.form.getFieldValue(`arrCantidad[${identifier}]`);
        var precioUnitarioOrigen = property === "arrPrecioUnitarioOrigen" ? newValue : this.props.form.getFieldValue(`arrPrecioUnitarioOrigen[${identifier}]`);
        var totalOrigen = property === "arrTotalOrigen" ? newValue : this.props.form.getFieldValue(`arrTotalOrigen[${identifier}]`);
        var precioUnitarioCosteo = property === "arrPrecioUnitarioCosteo" ? newValue : this.props.form.getFieldValue(`arrPrecioUnitarioCosteo[${identifier}]`);
        var totalCosteo = property === "arrTotalCosteo" ? newValue : this.props.form.getFieldValue(`arrTotalCosteo[${identifier}]`);
        
        var calculoPrecioUnitOrigen = precioUnitarioOrigen;
        var calculoPrecioTotalOrigen = cantidad * calculoPrecioUnitOrigen;
        var calculoPrecioUnitCosteo = precioUnitarioOrigen;
        var calculoPrecioTotalCosteo = cantidad * calculoPrecioUnitCosteo; 

        var itemProducto = {
            identifier,
            idProducto: _idProducto,
            fechaVencimiento,
            lote,
            nombre,
            cantidad,
            calculoPrecioUnitOrigen,
            calculoPrecioTotalOrigen,
            calculoPrecioUnitCosteo,
            calculoPrecioTotalCosteo
        }

        var arrDetalleProducto = this.props.form.getFieldValue("arrDetalleProducto");
        var arrDetalleProductoFilter = arrDetalleProducto.filter(m => { return m.identifier !== identifier });
        arrDetalleProductoFilter.push(itemProducto);

        this.props.form.setFieldsValue({
            arrDetalleProducto: arrDetalleProductoFilter,
            [`arrLote[${identifier}]`]: lote,
            [`arrNombre[${identifier}]`]: nombre,
            [`arrCantidad[${identifier}]`]: parseFloat(cantidad).toFixed(0),
            [`arrPrecioUnitarioOrigen[${identifier}]`]: parseFloat(calculoPrecioUnitOrigen).toFixed(3),
            [`arrTotalOrigen[${identifier}]`]: parseFloat(calculoPrecioTotalOrigen).toFixed(3),
            [`arrPrecioUnitarioCosteo[${identifier}]`]: parseFloat(calculoPrecioUnitCosteo).toFixed(3),
            [`arrTotalCosteo[${identifier}]`]: parseFloat(calculoPrecioTotalCosteo).toFixed(3),
        });
        this.props.form.setFieldsValue({
            arrDetalleProducto: arrDetalleProductoFilter
        });

        if (property === "arrCantidad" || property === "arrPrecioUnitarioOrigen") {
            this.onCalculatePrecioCosteo();    
        }
        
    }


    handleCalculateServicio = (identifier, property, value, numberDecimals, _idServicio) => {   
        debugger
        var newValue = this.fetchNewValue(value, numberDecimals);
        var params = auth.user().parametros;

        var tipoCambio = property === "arrTipoCambio" ? newValue : this.props.form.getFieldValue(`arrTipoCambio[${identifier}]`);
        var montoSoles = property === "arrSoles" ? newValue : this.props.form.getFieldValue(`arrSoles[${identifier}]`);
        var montoDolares = property === "arrDolares" ? newValue : this.props.form.getFieldValue(`arrDolares[${identifier}]`);

        var calculoEnDolares = 0;
        var calculoEnSoles = 0;

        if (property === "arrSoles" || property === "arrDolares"){
            if (property === "arrSoles" ) {
                calculoEnSoles = parseFloat(montoSoles);
                calculoEnDolares = (montoSoles / tipoCambio);
            }
            if (property === "arrDolares") {
                calculoEnSoles = (montoDolares * tipoCambio);
                calculoEnDolares = parseFloat(montoDolares);
            }
        }
        if (property === "arrTipoCambio") {
            calculoEnSoles = parseFloat(montoSoles);
            calculoEnDolares = (montoSoles / tipoCambio);
        }

        var itemServicio = {
            identifier,
            id: identifier,
            tipoCambio,
            calculoEnSoles,
            calculoEnDolares
        }

        var arrDetalleServicio = this.props.form.getFieldValue("arrDetalleServicio");
        var arrDetalleServicioFilter = arrDetalleServicio.filter(m => { return m.identifier !== identifier });
        arrDetalleServicioFilter.push(itemServicio);

        this.props.form.setFieldsValue({
            arrDetalleServicio: arrDetalleServicioFilter,
            [`arrTipoCambio[${identifier}]`]: parseFloat(tipoCambio).toFixed(3),
            [`arrSoles[${identifier}]`]: calculoEnSoles.toFixed(3),
            [`arrDolares[${identifier}]`]: calculoEnDolares.toFixed(3)
        });
        this.props.form.setFieldsValue({
            arrDetalleServicio: arrDetalleServicioFilter
        });

        this.onCalculatePrecioCosteo();

    }

    onCalculatePrecioCosteo = () => {
        debugger
        var arrDetalleServicio = this.props.form.getFieldValue("arrDetalleServicio");
        var arrDetalleProducto = this.props.form.getFieldValue("arrDetalleProducto");

        for (let index = 0; index < arrDetalleProducto.length; index++) {
            debugger
            const element = arrDetalleProducto[index];
        
            var sumaTotalOrigen = arrDetalleProducto.reduce((a, b) => a + (b['calculoPrecioTotalOrigen'] || 0), 0);
            var sumaTotalServicio = 0;
            if ("soles" == "soles") {
                sumaTotalServicio = arrDetalleServicio.reduce((a, b) => a + (b['calculoEnSoles'] || 0), 0);
            }

            var porcentaje = element.calculoPrecioUnitOrigen * 100 / sumaTotalOrigen;
            var distribucion = sumaTotalServicio * (porcentaje / 100);

            if (isNaN(distribucion)) {
                distribucion = 0;
            }
            
            var calculoPrecioUnitCosteo = element.calculoPrecioUnitOrigen + distribucion;
            var calculoPrecioTotalCosteo = calculoPrecioUnitCosteo * element.cantidad;

            arrDetalleProducto[index].calculoPrecioUnitCosteo = parseFloat(calculoPrecioUnitCosteo).toFixed(3);
            arrDetalleProducto[index].calculoPrecioTotalCosteo = parseFloat(calculoPrecioTotalCosteo).toFixed(3);

            this.props.form.setFieldsValue({
                [`arrPrecioUnitarioCosteo[${element.identifier}]`]: parseFloat(calculoPrecioUnitCosteo).toFixed(3),
                [`arrTotalCosteo[${element.identifier}]`]: parseFloat(calculoPrecioTotalCosteo).toFixed(3),
            });

        }

        this.props.form.setFieldsValue({
            arrDetalleProducto: arrDetalleProducto
        });
    }


    handleOk = (e) => {
        debugger
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                debugger
                const data = {
                    "id": values.id,
                    "idImportacionEstado": REGISTRADO,
                    "idAlmacen": values.idAlmacen.key,
                    "idMoneda": values.idMoneda.key,
                    "idProyecto": values.idProyecto === undefined ? null : values.idProyecto.key,
                    "idMovimiento": null,
                    "fechaMovimiento": null,
                    "fechaMovimientoStr": values.fechaValeStr.format('DD/MM/YYYY'),
                    "documento": null,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "observacion": values.observacion,
                    "fechaAnulo": null,
                    "usuarioAnulo": null,
                    "flag": true,
                    "importacionProductoDetalles": [],
                    "importacionServicioDetalles": [],
                    "importacionReferencias": [],
                    "idOrdenCompra": values.idOrdenCompra
                  }

                var arrDetalleServicio = this.props.form.getFieldValue("arrDetalleServicio");
                var arrDetalleProducto = this.props.form.getFieldValue("arrDetalleProducto");

                for (let index = 0; index < arrDetalleProducto.length; index++) {
                    const element = arrDetalleProducto[index];
                    const producto = {
                        "id": 0,
                        "item": index + 1,
                        "idImportacion": null,
                        "idOrdenCompra": values.idOrdenCompra,
                        "idProducto": element.idProducto,
                        "fecha": null,
                        "fechaStr": element.fechaVencimiento,//.format('DD/MM/YYYY'),
                        "lote": element.lote,
                        "nombre": element.nombre,
                        "cantidad": parseInt(element.cantidad),
                        "precioUnitario": parseFloat(element.calculoPrecioUnitOrigen),
                        "total": parseFloat(element.calculoPrecioTotalOrigen),
                        "precioUnitarioCosteo": parseFloat(element.calculoPrecioUnitCosteo),
                        "totalCosteo": parseFloat(element.calculoPrecioTotalCosteo)
                      }
                      data.importacionProductoDetalles.push(producto);
                }

                for (let index = 0; index < arrDetalleServicio.length; index++) {
                    const element = arrDetalleServicio[index];
                    
                    const servicio = {
                        "id": 0,
                        "idImportacion": null,
                        "idImportacionServicio": element.id,
                        "tipoCambio": parseFloat(element.tipoCambio),
                        "soles": parseFloat(element.calculoEnSoles),
                        "dolares": parseFloat(element.calculoEnDolares)
                      }
                      data.importacionServicioDetalles.push(servicio);
                }

                if (values.idTipoComprobante !== undefined) {
                    var count_referencias = values.idTipoComprobante.length;// - 1;
                    for (var i = 0; i < count_referencias; i++) {
                        var tc = values.idTipoComprobante[i];
                        if (tc !== undefined) {

                            const itemRef = {
                                "id": 0,
                                "idImportacion": 0,
                                "idReferenciaOrigen": 12,
                                "idReferencia": values.idOrdenCompra,
                                "idTipoComprobante": tc.key,
                                "serie": values.series[i],
                                "documento": values.documentos[i],
                                "flagInterno": 0
                            }

                            data.importacionReferencias.push(itemRef);
                        }
                    }
                }

                this.props.onSave(data, this.props.form);
            }
        });
    }

    render () {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalleProducto', { initialValue: this.props.formValues.arrListaDetalleProductos });
        getFieldDecorator('arrDetalleServicio', { initialValue: this.props.formValues.arrListaDetalleServicios });

        return (
            <Modal
                title="Nueva Importación"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('idOrdenCompra', { initialValue: this.props.formValues.idOrdenCompra })(
                        <input type="hidden" />
                    )}
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Documento">
                                <InputGroup compact>
                                    
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key)}
                                        disabled={this.props.formValues.isReadOnly}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : undefined
                                    // rules: [{
                                    //     required: true,
                                    //     message: 'Campo obligatorio.',
                                    // }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        disabled={this.props.formValues.isReadOnly}
                                    >
                                        {this.props.formValues.proyectos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group">
                        <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => this.props.onChange('fechaStr', value)}
                                                disabled={this.props.formValues.isReadOnly}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                                disabled={this.props.formValues.isReadOnly}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Documento Vale">
                                <InputGroup compact>
                                    
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('documentoVale', {
                                            initialValue: this.props.formValues.documentoVale
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha Vale">
                                {getFieldDecorator('fechaValeStr', {
                                    initialValue: moment(this.props.formValues.fechaValeStr, 'DD/MM/YYYY'),
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Requerido'
                                    }],
                                })(
                                    <DatePicker
                                        className="first-input"
                                        placeholder="Seleccione fecha"
                                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        format="DD/MM/YYYY"
                                        disabled={true}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idEstablecimiento", option.key)
                                        }}
                                        disabled={this.props.formValues.isReadOnly}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        disabled={this.props.formValues.isReadOnly}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                        disabled={this.props.formValues.isReadOnly}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <Button
                                        icon="plus"
                                        type="primary"
                                        onClick={() => this.props.onAgregarDetalle(this.props.form.setFieldsValue, this.props.form.getFieldValue)}
                                    >
                                        Agregar
                                    </Button>
                                }
                            >
                                <TabPane tab="Detalle de Productos" key="1">
                                    <Productos
                                        dataSource={this.props.formValues.listaDetalleProductos}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateProducto}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Servicios" key="2">
                                    <Servicios
                                        dataSource={this.props.formValues.listaDetalleServicios}
                                        onRemove={this.handleRemoverServicio}
                                        onCalculateServicio={this.handleCalculateServicio}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="3">
                                    <Referencias
                                        dataSource={this.props.formValues.listaDetalleReferencias}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }

}
export default Form.create()(FormModal)